import { User } from '@/generated/graphql';
import { createContext } from 'react';

export interface AuthContextType {
  user: User | null;
  logout: () => Promise<boolean>;
  login: (email: string, password: string) => Promise<{ user: User }>;
  signup: (email: string, password: string) => Promise<{ user: User }>;
  quickSignup: (name: string) => Promise<{ user: User }>;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  logout: async () => false,
  login: async () => Promise.reject(new Error('Not implemented')),
  signup: async () => Promise.reject(new Error('Not implemented')),
  quickSignup: async () => Promise.reject(new Error('Not implemented')),
});
